import React, { useContext } from "react";
import "../../../index.css";

//context
import { SecondInputFormDataContext } from "../../../context/SecondInputFormDataContext";

const GenerateHeadOfDepartmentStatement = ({ department }) => {
  const {
    nameSurname,
    projectTitle,
    deanData,
    projectAcronym,
    vocation,
    equipmentStorageLocation,
    newEmploymentsWorkspace,
  } = useContext(SecondInputFormDataContext);

  const handlePDF = async () => {
    try {
      // Dynamically import PDF dependencies
      const { pdf } = await import("@react-pdf/renderer");
      const { default: DepartmentHeadStatementPDF } = await import(
        "../PDF/DepartmentHeadStatementPDF"
      );

      const doc = (
        <DepartmentHeadStatementPDF
          nameSurnameApplicant={nameSurname}
          nameSurnameDepartmentHead={
            department.fullName.split(" - ")[1].trim() || ""
          }
          departmentName={department.fullName.split(" - ")[0].trim() || ""}
          projectName={projectTitle}
          projectAcronym={projectAcronym}
          deanName={deanData.name}
          vocation={vocation}
          equipmentStorageLocation={equipmentStorageLocation}
          newEmploymentsWorkspace={newEmploymentsWorkspace}
        />
      );

      const blob = await pdf(doc).toBlob();
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = "Izjava predstojnika zavoda.pdf";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Error generating PDF:", err);
    }
  };

  return (
    <div id="generiraj-izjavu-predstojnika-zavoda-container">
      <button onClick={handlePDF} className="default-button">
        GENERIRAJ IZJAVU PREDSTOJNIKA ZAVODA
      </button>
    </div>
  );
};

export default GenerateHeadOfDepartmentStatement;
